// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';

class BorrowerAttestsNoDebtRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    // It's the only question showing up on the UI in this section and the following questions there are dependent on this one
    // and will not be shown if this one is not answered or the answer is "No"
    // This question is always required
    return RulesetResult.REQUIRED;
  };
}

export default new BorrowerAttestsNoDebtRuleset();
